import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";
import {Observable, of} from "rxjs";
import {catchError} from "rxjs/operators";
import {UserService} from "../services/user/user.service";

@Injectable({
  providedIn: "root",
})
export class UserResolver implements Resolve<boolean> {
  constructor(private _userService: UserService) {
  }

  resolve(): Observable<any> {

    return this._userService.getAll().pipe(
      catchError((error) => {
        return of("No data");
      })
    );

  }
}
